import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UserService } from '../services/user.service';
import { AcctCreateService } from '../services/acct-create.service';
import { Router, RouterModule } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import firebase from 'firebase/compat/app';
import 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { onAuthStateChanged } from 'firebase/auth';
import {TeacherService} from "../services/teacher.service";
import {Teacher} from "../interfaces/teacher";

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, CommonModule],
  templateUrl: './landing.component.html',
  styleUrls:[
    './landing.component.css',
    '../app.component.css',
  ],
}
)
export class LandingComponent {
  emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+(@ggc.edu|@gcpsk12.org)+$/, "i");
  isAdmin = false;

  constructor(private router: Router, private teacherService: TeacherService ){};
  route: ActivatedRoute= inject(ActivatedRoute)
  userService = inject(UserService)

  loginForm = new FormGroup({
    userEmail: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  })

  acctSevice = inject(AcctCreateService)
  createForm = new FormGroup({
    title: new FormControl(''),
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    middleInit: new FormControl(''),
    grade: new FormControl(''),
    school: new FormControl(''),
    email: new FormControl(''),
    password: new FormControl(''),
    passCOnf: new FormControl(''),
  })

  showInvalidCredientialsToast() {
    const toastEl = document.getElementById('loginToast');
    if (toastEl) {
      const toast = new (window as any).bootstrap.Toast(toastEl);
      toast.show();
      console.log('show');
    }
  }

  // submitLogIn(){
  //   this.userService.submitLogIn(
  //     this.loginForm.value.userEmail ?? '',
  //     this.loginForm.value.password ?? '',
  //   )
  //   const uid = this.userService.getUID();
  //   console.log(uid);
  //   if (uid == undefined){
  //     //alert("Login failed. Please check your credentials.");
  //     const badLoginMsg = (document.querySelector("#badLoginMsg") as HTMLParagraphElement);

  //     if (badLoginMsg){
  //       badLoginMsg?.classList.remove("hidden");

  //     }
  //   }
  // }

  incorrectLogin = false;
  async submitLogIn() {
    if (this.loginForm.invalid) {
      return;
    }
    const email = this.loginForm.value.userEmail ?? '';
    const teacher = await this.teacherService.getTeacherByEmail(email); // fetch by email

    if (!teacher || !teacher.isActive) {
      this.showInvalidCredientialsToast();
      this.incorrectLogin = true;
      return;
    }


    const success = await this.userService.submitLogIn(
      this.loginForm.value.userEmail ?? '',
      this.loginForm.value.password ?? ''
    );

    if (success) {
      this.incorrectLogin = false;

      if (this.isAdmin) {
        await this.router.navigate(['/find-projects']);
      } else {
        await this.router.navigate(['/find-projects']);
      }
    } else {
      this.showInvalidCredientialsToast();
      this.incorrectLogin = true;
    }
  }

  toggleHidden(idOne: string, idTwo: string){
    const login = document.querySelector(idOne);
    const signUp = document.querySelector(idTwo);
    const maincontainer = document.querySelector(".maincontainer");
    maincontainer?.classList.toggle("loginCard");
    maincontainer?.classList.toggle("signupCard");
    login?.classList.toggle("hidden");
    signUp?.classList.toggle("hidden");
    signUp?.classList.toggle("signupSize");
  }

  registerEmailSent = false;
  registerFailed = false;
  async createAcct(){
    const success = await this.acctSevice.createAcct(
      this.createForm.value.email ?? ''
    );

    if (success) {
      this.registerEmailSent = true;
    } else {
      this.registerFailed = true;
    }
  }

  async resetPassword() {
    try {
      await this.acctSevice.sendResetPassword(this.createForm.value.email ?? '');
      alert("Password reset email sent!");
    } catch (err) {
      console.error(err);
      alert("Something went wrong sending the reset email.");
    }
  }


  checkEmails(){
    const email = (document.querySelector("#emailInput") as HTMLInputElement).value;
    const confEmail = (document.querySelector("#confEmailInput") as HTMLInputElement).value;
    if (email == confEmail && this.emailRegex.test(email)){
      const submitBTN = document.querySelector("#submitEmailbtn") as HTMLButtonElement;
      submitBTN.classList.remove('disabled');
      submitBTN.removeAttribute('disabled');
    } else {
      const submitBTN = document.querySelector("#submitEmailbtn") as HTMLButtonElement;
      submitBTN.classList.add('disabled');
      submitBTN.setAttribute('disabled', 'true');
    }
  }

  teacher: Teacher | null = null;
  schools : any [] = [];
  async ngOnInit() {
    await this.getSchools();

    this.userService.isAdmin$.subscribe((isAdmin) => {
      this.isAdmin = isAdmin;
    });

    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      if (user?.uid){
        await this.router.navigate(['/find-projects']);
      }
    })
  }
  async getSchools(){
    const snapshot = await firebase.firestore().collection('school').get();
    snapshot.forEach((doc) => this.schools.push((doc.data())));
    this.schools.sort((a, b) => a.name.localeCompare(b.name))
  }


  showRegister() {
    const loginFields = document.getElementById('loginFields');
    const registerFields = document.getElementById('registerFields');
    const forgotPassword = document.getElementById('forgotPassword');

    loginFields?.classList.remove('show');
    forgotPassword?.classList.remove('show');
    registerFields?.classList.add('show');

    this.registerEmailSent = false;
    this.registerFailed = false;
  }
  showForgotPassword() {
    const loginFields = document.getElementById('loginFields');
    const registerFields = document.getElementById('registerFields');
    const forgotPassword = document.getElementById('forgotPassword');

    loginFields?.classList.remove('show');
    registerFields?.classList.remove('show');
    forgotPassword?.classList.add('show');
  }
  showLogin() {
    const loginFields = document.getElementById('loginFields');
    const registerFields = document.getElementById('registerFields');
    const forgotPassword = document.getElementById('forgotPassword');

    registerFields?.classList.remove('show');
    forgotPassword?.classList.remove('show');
    loginFields?.classList.add('show');
  }


}
